<template>
  <section class="service" id="service">
    <div class="container content">
      <div class="text-col wow slideInLeft">
        <h2>Služby</h2>
        <p>
          Vitajte v našej rozmanitej ponuke služieb, kde sme sa snažili splniť
          vaše potreby a poskytnúť vám vynikajúci zážitok. Sme tu, aby sme vás
          podporili vo vašej ceste k lepšiemu zdraviu, kondícii a pohodliu.
        </p>
        <p>
          Od tréningových programov po wellness služby, naše široké spektrum
          služieb je navrhnuté tak, aby vám pomohlo dosiahnuť vaše ciele
          a cítiť sa najlepšie vo vašom tele.
        </p>
      </div>
      <div class="accordion-col wow slideInRight">
        <div
          v-for="(item, index) in accordionItems"
          :key="index"
          class="accordion-item"
          :class="{ active: activeAccordion === index }"
          @click="toggleAccordion(index)"
        >
          <div class="accordion-head">
            <h4>{{ item.title }}</h4>
            <i class="fa" :class="activeAccordion === index ? 'fa-angle-up' : 'fa-angle-down'"></i>
          </div>
          <transition name="accordion">
            <div class="accordion-body" v-show="activeAccordion === index">
              <p>{{ item.body }}</p>
              <button v-if="item.linkFn" @click.stop="item.linkFn" class="link-btn">
                Link na recenzie
              </button>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { ref } from 'vue'
export default {
  name: "ServiceSection",
  setup() {
    const activeAccordion = ref(null)

    const toggleAccordion = (index) => {
      activeAccordion.value = activeAccordion.value === index ? null : index
    }

    const openReviewLink = () => {
      window.open(
        'https://www.google.com/maps/place/Diamond+Gym/@48.3092603,18.0748924,17z/',
        '_blank'
      )
    }

    const accordionItems = [
      {
        title: 'Silový tréning',
        body: 'Silový tréning je účinná forma cvičenia, ktorá zvyšuje svalovú silu a výkon. Pomáha budovať svalovú hmotu, zlepšuje metabolizmus a prispieva k lepšej postave.',
      },
      {
        title: 'Kondičný tréning',
        body: 'Kondičný tréning je základným pilierom udržiavania celkového zdravia a kondície, zlepšuje srdcovo-cievny výkon, vytrvalosť, flexibilitu a silu.',
      },
      {
        title: 'Bar',
        body: 'V našom bare so supplementmi nájdete výber kvalitných výživových doplnkov, ktoré podporujú svalový rast a regeneráciu.',
      },
      {
        title: 'Recenzie',
        body: 'Recenzie sú hodnotenia a skúsenosti ľudí s produktmi a službami, pomáhajú informovať a usmerňovať zákazníkov.',
        linkFn: openReviewLink,
      },
    ]

    return {
      activeAccordion,
      toggleAccordion,
      accordionItems,
    }
  }
}
</script>

<style scoped>
.service {
  background-color: #0a0a0a;
  border-top: 2px solid #E8B923;
  border-bottom: 2px solid #E8B923;
}

.content {
  display: flex;
  gap: 48px;
  align-items: flex-start;
}

/* Text column */
.text-col {
  flex: 1 1 45%;
}

.text-col h2 {
  font-size: clamp(26px, 4vw, 36px);
  color: #E8B923;
  margin-bottom: 16px;
  position: relative;
}

.text-col h2::after {
  content: '';
  display: block;
  width: 48px;
  height: 3px;
  background: #E8B923;
  border-radius: 2px;
  margin-top: 10px;
}

.text-col p {
  font-size: 15px;
  line-height: 1.75;
  color: #bbb;
  margin-bottom: 14px;
}

/* Accordion column */
.accordion-col {
  flex: 1 1 45%;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.accordion-item {
  background: #1a1a1a;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid transparent;
  cursor: pointer;
  transition: border-color 0.25s ease, background-color 0.25s ease;
}

.accordion-item:hover,
.accordion-item.active {
  background-color: #222;
  border-color: rgba(232, 185, 35, 0.3);
}

.accordion-head {
  padding: 16px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}

.accordion-head h4 {
  font-size: 15px;
  font-weight: 600;
  color: #E8B923;
}

.accordion-head .fa {
  font-size: 16px;
  color: #E8B923;
  transition: transform 0.3s ease;
  flex-shrink: 0;
}

.accordion-item.active .accordion-head .fa {
  transform: rotate(180deg);
}

.accordion-body {
  padding: 14px 20px 18px;
  border-top: 1px solid #2d2d2d;
  color: #bbb;
  font-size: 14px;
  line-height: 1.7;
}

.link-btn {
  margin-top: 12px;
  padding: 8px 18px;
  background-color: #E8B923;
  border: none;
  color: #000;
  font-size: 14px;
  font-weight: 600;
  font-family: "Montserrat", sans-serif;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.25s ease, transform 0.2s ease;
}

.link-btn:hover {
  background-color: #d0a31e;
  transform: translateY(-1px);
}

/* Accordion transition */
.accordion-enter-active,
.accordion-leave-active {
  transition: opacity 0.25s ease, max-height 0.3s ease;
  max-height: 300px;
  overflow: hidden;
}

.accordion-enter-from,
.accordion-leave-to {
  opacity: 0;
  max-height: 0;
}

/* Responsive */
@media (max-width: 860px) {
  .content {
    flex-direction: column;
    gap: 32px;
  }

  .text-col,
  .accordion-col {
    flex: 1 1 100%;
  }
}

@media (max-width: 540px) {
  .text-col {
    text-align: center;
  }

  .text-col h2::after {
    margin: 10px auto 0;
  }

  .accordion-head {
    padding: 14px 16px;
  }

  .accordion-body {
    padding: 12px 16px 16px;
  }
}
</style>
